import React, { useState } from "react";
import { Button, Divider, Modal, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

// import { switchQuestion } from "../../../actions/traineeAction";
import { switchQuestion } from "../../../reducers/trainee";
import Clock from "./clock";
import { useWindowDimensions } from "./testBoard";
import { useSocket } from "../../../context/SocketContext";

export const truncateString = (inputString, maxLength) => {
  if (inputString?.length <= maxLength) {
    return inputString;
  }
  return inputString?.substring(0, maxLength);
};

const TestBoardHeader = (props) => {
  const { testName, next, previous, handleSubmitOpen, isSubmitted,trainee } = props;
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { width } = useWindowDimensions();
  const socket = useSocket();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // const trainee = useSelector((state) => state.trainee);
  // console.log(trainee);
  

  const handleOpen = () => setIsModalOpen(true);
  const handleCancel = () => setIsModalOpen(false);

  const handleLeaveAssignment = () => {
    dispatch(switchQuestion(0));
    // if (socket.off) {
    //   trainee?.socket?.current.disconnect();
    // }
    navigate("/user/livetest");
  };

  return (
    <>
      <div className="headerParrentWrapper">
        <div className="headerLeft">
          <Typography
            style={{ cursor: "pointer" }}
            className="exit"
            onClick={handleOpen}
          >
            {width <= 500 ? "exit" : "exit assessment"}
          </Typography>
          <Button
            style={{ borderRadius: "30px" }}
            type="primary"
            onClick={previous}
            className="testHeaderButton"
          >
            Previous
          </Button>
        </div>
        <div className="headerInner">
          <Typography className="hederTestName">
            {testName
              ? width <= 600
                ? truncateString(testName, 15)
                : truncateString(testName, 40)
              : null}
          </Typography>
          <Divider className="testHeaderDivider" />
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
              justifyContent: "center",
            }}
          >
            <Typography className="testHeaderTimeText">
              {width <= 600 ? "" : " Time Left:"}
            </Typography>
            <Clock trainee={trainee}/>
          </div>
        </div>
        <div className="headerRight">
          <Button
            style={{ borderRadius: "30px" }}
            className="testHeaderButton"
            type="primary"
            onClick={isSubmitted ? handleSubmitOpen : next}
          >
            {isSubmitted ? "Submit" : "Next >"}
          </Button>
        </div>
      </div>

      <Modal
        open={isModalOpen}
        footer={null}
        closable={false}
        centered
        onCancel={handleCancel}
        width={350}
        style={{ borderRadius: "25px", zIndex: 999999 }}
      >
        <p className="modalTitle">Are you sure you want to leave the assignment?</p>
        <div className="modalButtons">
          <Button className="modalButtonNo" onClick={handleCancel}>
            Cancel
          </Button>
          <Button className="modalButtonNo" onClick={handleLeaveAssignment}>
            Yes
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default TestBoardHeader;
